<template>
  <b-container fluid>
    <b-row
      class="px-2"
      align-v="center"
    >
      <b-col
        md="7"
        lg="9"
        cols="12"
      >
        <label>
          {{ $t('actions.filter-fields') }}
        </label>
      </b-col>
    </b-row>
    <b-row
      class="px-2"
      align-v="center"
      align-h="between"
    >
      <b-col
        md="9"
        sm="6"
        cols="12"
      >
        <s-multiselect
          v-model="selectedVariables"
          @input="checkEmpty"
          :proxy-binds="{
            label:'name',
            placeholder: $t('supervision.sensors-filter-label'),
            trackBy:'id',
            options: variables,
          }"
          :withInternalSearch="false"
          @search-change="handleSearchChange"
        />
      </b-col>
      <b-col
        md="3"
        sm="6"
        cols="12"
        class="mt-2 mt-sm-0"
      >
        <b-button
          block
          variant="primary"
          @click="applyFilter"
          :disabled="!selectedVariables.length"
        >
          {{ $t('actions.filter') }}
        </b-button>
      </b-col>
      <b-col
        v-if="$hasUserPermission('PER016')"
        class="mt-2"
        cols="12"
      >
        <b-form-checkbox
          v-model="showHiddenVariables"
          @change="toggleVisibility">
          {{ $t('sensors.actions.show-hidden-variables') }}
        </b-form-checkbox>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: 'GeneralFilters',
  props: {
    variables: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    selectedVariables: [],
    showHiddenVariables: false,
  }),
  methods: {
    toggleVisibility() {
      setTimeout(() => {
        this.$emit('toggle-hidden-variables', this.showHiddenVariables);
      }, 100);
    },
    applyFilter() {
      this.$emit('apply-filter', this.selectedVariables);
    },
    checkEmpty() {
      if (this.selectedVariables.length) {
        return;
      }
      this.$emit('apply-filter', []);
    },
    handleSearchChange(search) {
      this.$emit('search-change', search);
    },
  },
};
</script>
